
import { autoCompleteEndereco } from "services/FormFunctions"

import { LineWithText } from "components/FormGerarGuia"
import { DropdownInput, ListInput, Switch, TextInput, TextWithButtonInput } from "components/Inputs"

import { inputGroupNames } from "constants/inputGroupNames"

import searchIcon from "assets/searchIcon.png"
import listBairrosAju from "json/BairrosAju.json"
import { docField } from "./InputFieldsDocumentos"


const searchImg = <img src={searchIcon} className="mx-1" width="20px" height="20px" alt="ícone"/>
const docsGeradoresMulta = ["Notificação", "Auto de infração", "Auto de embargo", "Processo", "Memorando", "Ofício"]
const fieldsDocOrigemMulta =
[
    {"type": "dropdown", "name": inputGroupNames.DocsOrigemMulta, "label": "Documento de origem", "value": "Doc. origem", "itemsList": docsGeradoresMulta},
    {"type": "text", "name": "numDocOrigem" + inputGroupNames.DocsOrigemMulta, "placeholder": "00.000", "label": "N° do documento", "maxLength": "10"},
    {"type": "text", "name": "anoDocOrigem" + inputGroupNames.DocsOrigemMulta, "placeholder": "0000", "label": "Data do documento", "maxLength": "10", "mask": "99/99/9999"}
]
const fieldsTestemunha =
[
    {"type": "text", "name": "testemunhaNome", "placeholder": "", "label": "Testemunha", "value": "", "req": true, "info": "", "maxLength": "150", "mask": <></>},
    {"type": "text", "name": "testemunhaEndereco", "placeholder": "", "label": "Endereço", "value": "", "req": true, "info": "", "maxLength": "150", "mask": <></>}
]

export const field =
{  
    bairroNacional: () => { return <TextInput Name={"bairroProprietario"} Label={"Bairro"} /> },
    complemento: () => { return <TextInput Name={"complementoProprietario"} Label={"Complemento"} MaxLength={50} /> },
    cpfCnpjProprietario: (placeholder, mask) => { return <TextInput Name={"cpfCnpjProprietario"} Placeholder={placeholder} Label={"CPF / CNPJ"} Mask={mask} /> },
    // dataAutoEmbargo: () => { return <TextInput Name={"dataAutoEmbargo"} Placeholder={"00/00/0000"} Label={"Data de emissão"} Mask={"99/99/9999"}/> },
    // dataAutoInfracao: () => { return <TextInput Name={"dataAutoInfracao"} Placeholder={"00/00/0000"} Label={"Data de emissão"} Mask={"99/99/9999"}/> },
    logradouro: () => { return <TextInput Name={"logradouroProprietario"} Placeholder={"Rua das Palmeiras"} Label={"Endereço"} MaxLength={50} /> },
    nomeProprietario: () => { return <TextInput Name={"nomeProprietario"} Placeholder={"Fulano da Silva"} Label={"Nome do proprietário"} MaxLength={100} /> },
    // numAutoEmbargo: () => { return <TextInput Name={"numAutoEmbargo"} Placeholder={"00000"} Label={"N° do Auto de Embargo"} /> },
    // numAutoInfracao: () => { return <TextInput Name={"numAutoInfracao"} Placeholder={"00000"} Label={"N° do Auto de Infração"} /> },
    numPorta: () => { return <TextInput Name={"numPortaProprietario"} Placeholder={"000"} Label={"N° de porta"} MaxLength={5} /> },
    vencimento: () => { return <TextInput Name={"vencimento"} Placeholder={"00/00/0000"} Label={"Vencimento"} Value={""} Req={true} Info={""} Mask={"99/99/9999"}/> },

    servico: () => { return docField.servico() },

    bairro: () => { return <DropdownInput Name={"bairroProprietario"} ItemsList={listBairrosAju} Label={"Bairro"} Value={"Bairro"} MinWidth={"207px"} /> },

    // switchAutoEmbargo: (temAutoDeEmbargo, onChangeTemAutoDeEmbargo) => { return <Switch Name={"switchAutoEmbargo"} Checked={temAutoDeEmbargo} Label={"Tem auto de embargo"} OnChange={onChangeTemAutoDeEmbargo}/> },
    // switchAutoInfracao: (temAutoDeInfracao, onChangeTemAutoDeInfracao) => { return <Switch Name={"switchAutoInfracao"} Checked={temAutoDeInfracao} Label={"Tem auto de infração"} OnChange={onChangeTemAutoDeInfracao}/> },
    switchCNPJ: (onChangeCPFCNPJ) => { return <Switch Name={"switchCNPJ"} Label={"CNPJ"} OnChange={onChangeCPFCNPJ} /> },

    cep: () => { return <TextWithButtonInput Name={"cepProprietario"} Placeholder={"49.000-00"} Label={"CEP"} MaxLength={10} Mask={"99.999-999"} OnClick={autoCompleteEndereco} ButtonImg={searchImg} /> },

    docsOrigemMulta: (qtd) => { return <ListInput name={inputGroupNames.DocsOrigemMulta} Type={"listGroupText"} fields={fieldsDocOrigemMulta} InitNumberItems={qtd} /> },
    testemunha: (qtd) => { return <ListInput name={inputGroupNames.Testemunha} Type={"listGroupText"} fields={fieldsTestemunha} InitNumberItems={qtd}  /> }
}

export const section =
{
    // autoEmbargo: (temAutoDeEmbargo, onChangeTemAutoDeEmbargo) =>
    // {
    //     if (!temAutoDeEmbargo)
    //     { 
    //        return (
    //             <>
    //                 <LineWithText text={"Auto de embargo"} />
    //                 {field.switchAutoEmbargo(temAutoDeEmbargo, onChangeTemAutoDeEmbargo)}
    //             </>
    //         )
    //     }
        
    //     return (
    //         <>   
    //             <LineWithText text={"Auto de embargo"} />
    //             {field.switchAutoEmbargo(temAutoDeEmbargo, onChangeTemAutoDeEmbargo)}
    //             <div className="d-flex">
    //                 {field.numAutoEmbargo()}
    //                 {field.dataAutoEmbargo()}
    //             </div>
    //         </>
    //     )
    // },
    // autoInfracao: (temAutoDeInfracao, onChangeTemAutoDeInfracao, temTestemunhas) =>
    // {
    //     if (!temAutoDeInfracao)
    //     { 
    //        return (
    //             <>
    //                 <LineWithText text={"Auto de infração"} />
    //                 {field.switchAutoInfracao(temAutoDeInfracao, onChangeTemAutoDeInfracao)}
    //             </>
    //         )
    //     }

    //     return (
    //         <div className="mb-3">
    //             <LineWithText text={"Auto de infração"} />
    //             {field.switchAutoInfracao(temAutoDeInfracao, onChangeTemAutoDeInfracao)}
    //             <div className="d-flex">
    //                 {field.numAutoInfracao()}
    //                 {field.dataAutoInfracao()}
    //             </div>
    //             {temTestemunhas ? field.testemunha() : <></>}
    //         </div>
    //     )
    // },
    documentoOrigem: (qtdInicial) =>
    {    
        return (
            <>
                <LineWithText text={"Documento de origem"} />
                <div className="d-flex"> 
                    {field.docsOrigemMulta(qtdInicial)}
                </div>
            </>
        )
    },
    enderecoProprietario: (temEnderecoObra) =>
    {
        return (
            <>
                <LineWithText text={"Endereço do proprietário"} />
                <div className="d-flex"> 
                    {field.cep()}
                </div>
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column justify-content-end">
                        {temEnderecoObra ? field.bairroNacional() : field.bairro()}
                    </div>
                    {field.numPorta()}
                </div>
                {field.logradouro()}
                {field.complemento()}
            </>
        )
    },
    proprietario: (onChangeCPFCNPJ, placeholderCpfCnpj, maskCpfCnpj) =>
    {
        return (
            <>
                <LineWithText text={"Informações do proprietário"} align="center" />
                <div>
                    <div className="d-flex">
                        <div className="w-50">
                        </div>
                        <div className="w-50">
                            {field.switchCNPJ(onChangeCPFCNPJ)}
                        </div>
                    </div>
                    <div className="d-flex">
                        {field.nomeProprietario()}
                        {field.cpfCnpjProprietario(placeholderCpfCnpj, maskCpfCnpj)}
                    </div>
                </div>
            </>
        )
    },
    vencimento: () =>
    {
        return (
            <>     
                <LineWithText text={"Dados adicionais"} />
                <div className="d-flex justify-content-between mb-3">
                    <div className="d-flex flex-column justify-content-end">
                        {field.servico()}
                    </div>
                    {field.vencimento()}
                </div>
            </>
        )
    }
}